module.exports = __webpack_public_path__ + "static/img/hotelface.00d689b.png";


//////////////////
// WEBPACK FOOTER
// ./static/Brand/GreenTreeDetail/hotelface.png
// module id = 1146
// module chunks = 18